const CSS = `.selc-form{max-width:460px;margin:0 auto;font-family:inherit;display:flex;flex-direction:column;gap:14px}
.selc-form label{font-size:13px;font-weight:600;color:#1f2937;display:block;margin-bottom:6px}
.selc-form input[type=text],.selc-form input[type=email],.selc-form input[type=tel],.selc-form select{width:100%;box-sizing:border-box;padding:12px 14px;border:1px solid #d1d5db;border-radius:10px;font-size:15px;background:#fff;color:#111}
.selc-form input:focus,.selc-form select:focus{outline:none;border-color:#A38560;box-shadow:0 0 0 3px rgba(163,133,96,.2)}
.selc-radios{display:flex;gap:10px}.selc-radios label{flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:11px;border:1px solid #d1d5db;border-radius:10px;font-weight:500;cursor:pointer;margin:0}
.selc-consent{display:flex;gap:8px;align-items:flex-start;font-size:12px;color:#4b5563}.selc-consent label{font-weight:400;font-size:12px;color:#4b5563;margin:0}
.selc-btn{padding:14px;border:0;border-radius:10px;background:#A38560;color:#fff;font-size:16px;font-weight:700;cursor:pointer}.selc-btn:disabled{opacity:.6}
.selc-msg{font-size:14px;text-align:center}`;

const FIELDS = {
  'curso-clase-ig': `
  <div><label>Nombre *</label><input type="text" name="name" required autocomplete="name"></div>
  <div><label>Correo *</label><input type="email" name="email" required autocomplete="email"></div>`,
  'curso-interes-ig': `
  <div><label>Correo *</label><input type="email" name="email" required autocomplete="email"></div>
  <div><label>Celular *</label><input type="tel" name="phone" required autocomplete="tel" placeholder="300 123 4567"></div>
  <div><label>¿Cuánto tiempo llevas como agente? *</label><select name="years_as_agent" required>
    <option value="">Selecciona una opción</option><option value="lt1">Menos de 1 año</option><option value="1-5">Entre 1 y 5 años</option><option value="gt5">Más de 5 años</option></select></div>
  <div><label>¿Tienes actualmente Instagram inmobiliario? *</label><div class="selc-radios">
    <label><input type="radio" name="has_instagram" value="si" required> Sí</label><label><input type="radio" name="has_instagram" value="no"> No</label></div></div>`,
};

export function generateCourseEmbed(form, apiUrl, thankYouUrl) {
  const id = `selc-${form.id}`;
  return `<!-- SELECTO CRM · ${form.name} (${form.source}) -->
<style>${CSS}</style>
<form id="${id}" class="selc-form" novalidate>${FIELDS[form.id]}
  <div class="selc-consent"><input type="checkbox" id="${id}-consent" name="consent" required><label for="${id}-consent">Autorizo el tratamiento de mis datos personales de acuerdo con la política de privacidad.</label></div>
  <button type="submit" class="selc-btn">Enviar</button>
  <div class="selc-msg" aria-live="polite"></div>
</form>
<script>
(function(){
  var f=document.getElementById('${id}'),msg=f.querySelector('.selc-msg'),btn=f.querySelector('button');
  f.addEventListener('submit',async function(e){
    e.preventDefault();
    if(!f.checkValidity()){f.reportValidity();return;}
    var d=new FormData(f),q=new URLSearchParams(location.search),x={consent:d.get('consent')?'on':''};
    ['years_as_agent','has_instagram'].forEach(function(k){if(d.get(k))x[k]=d.get(k);});
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){if(q.get(k))x[k]=q.get(k);});
    var b={form_id:'${form.id}',source:'${form.source}',assignment_code:'${form.assignment_code}',name:d.get('name')||'',email:d.get('email')||'',phone:d.get('phone')||'',extra_fields:x};
    btn.disabled=true;msg.textContent='Enviando…';
    try{
      var r=await fetch('${apiUrl}/api/leads/external',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(b)});
      if(!r.ok){var j={};try{j=await r.json();}catch(_e){}throw new Error(j.detail||'Error');}
      f.reset();${thankYouUrl ? `location.href='${thankYouUrl}';` : `msg.style.color='#15803d';msg.textContent='¡Gracias! Ya quedaste registrado.';`}
    }catch(err){msg.style.color='#b91c1c';msg.textContent=err.message||'No se pudo enviar, intenta de nuevo.';}
    btn.disabled=false;
  });
})();
</script>`;
}
